export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImE2NmM1OGI0LWQwMjItNGRkMC1iZWUzLTNkYjY3YjA2MmIxZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.hPXGdZanGvxT48fh65PgXhQtzcuweLMh1WGxe8sJVEIgC2UgGomIsRNNCkJQPbL99dv1bhX5WhinIpAEcPv5x8CCI2WJc/JKL8JzGTYoOQUXlCmYI5oy22QmKYxpAqbDvOtvZg==';
